import React, { useState, useEffect } from "react";
import crossPink from "../../../images/crossPink.png";
import calendarOpen from "../../../images/calender.png";
import calendarClose from "../../../images/calendarDefault.png";
import pdf from "../../../images/pdf.png";
import { format } from "date-fns";
import fileIcon from "../../../images/redAlert.png";
import yellowWarning from "../../../images/yellowWarning.png";
import CompletedIcon from "../../../images/checkImage.png";
import styles from "./ViewSourceRecord.module.scss";
import CommonSelectField from "../../../Components/CommonFields/CommonSelectField";
import CommonSwitch from "../../../Components/CommonFields/CommonSwitch";
import CommonInputField from "../../../Components/CommonFields/CommonInputField";
import CommonDateField from "../../../Components/CommonFields/CommonDateField";
import { Dialog, Classes, Icon, Intent } from "@blueprintjs/core";
import axios from "axios";
import { TenantID, GET } from "../../dataSaver";
import { Auth } from "../../../utils/auth";
import CommonLabel from "../../../Components/CommonFields/CommonLabel";

const ViewSourceRecord = ({ isOpen, onClose, contractId, contractData }) => {
  console.log("ViewSourceRecord rendered ", { contractId, contractData });

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [apiContractData, setApiContractData] = useState(null);
  const [apiContracts, setApiContracts] = useState(null);
  const [workflowData, setWorkflowData] = useState(null);
  let [displayEcats, setDisplayEcats] = useState(null);
  const [siteControlledAtSiteLevel, setSiteControlledAtSiteLevel] = useState(false);
  const [sitesData, setSitesData] = useState([]);
  // Fetch sites data (like InvoiceReviewStep)
  const fetchSites = async () => {
    try {
      const { data: sites } = await GET('entity-service/sites');
      setSitesData(sites || []);
      return sites || [];
    } catch (error) {
      console.error('Error fetching sites:', error);
      setSitesData([]);
      return [];
    }
  };

  const [formData, setFormData] = useState({
    contractId: contractData?.contractId || "228159-2",
    ecatsId: contractData?.ecatsId || "7837428 -12-THC_622299",
    recordName:
      contractData?.recordName ||
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed diam nonumy eirmod tempor invidunt ut labore et",
    startDate: contractData?.startDate || "",
    endDate: contractData?.endDate || "",
    fullyExecuted: contractData?.fullyExecuted || true,
    specificProviders: contractData?.specificProviders || true,
    serviceProviderType: contractData?.serviceProviderType || "physician",
    contractorFirstName: contractData?.contractorFirstName || "",
    contractorMiddleName: contractData?.contractorMiddleName || "",
    contractorLastName: contractData?.contractorLastName || "",
    contractorSuffix: contractData?.contractorSuffix || "",
    vendorNPIN: contractData?.vendorNPIN || "",
    vendorUsingEntity: contractData?.vendorUsingEntity || false,
    businessEntityName:
      contractData?.businessEntityName || "Aye Thandar Win dba UTW, LLC",
    businessContactFirstName: contractData?.businessContactFirstName || "Aye",
    businessContactLastName:
      contractData?.businessContactLastName || "Thandar Win dba UTW, LLC",
    businessEmail: contractData?.businessEmail || "win.ayer@email.com",
    cellPhone: contractData?.cellPhone || "85016-0000",
    streetAddress:
      contractData?.streetAddress || "C/O AYE THANDAR WIN 4934 E RD",
    city: contractData?.city || "PHOENIX",
    state: contractData?.state || "AZ",
    zipcode: contractData?.zipcode || "STE 120443",
  });

  useEffect(() => {
    const loadGeneralConfig = async () => {
      try {
        const { fetchGeneralConfig } = await import("../../../utils/generalConfig");
        const data = await fetchGeneralConfig();
        if (data) {
          setEcatsLabel(data?.externalContractIdLabel);
          setDisplayEcats(data?.externalContractIdLabel !== "" && data?.externalContractIdLabel != null && data?.externalContractIdLabel !== "Contract ID");
        }
      } catch (e) {
        console.error("Failed to load general config", e);
      }
    };

    loadGeneralConfig();
  }, []);


  const [ecatsLabel, setEcatsLabel] = useState(null);


  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleToggle = (field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const fetchContractData = async () => {
    if (!contractId) {
      console.log("No contractId provided, skipping API call");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const apiUrl = `contract-managment-service/contracts/${contractId}`;
      console.log("Fetching contract data with API URL:", apiUrl);

      const response = await GET(apiUrl);
      console.log("Contract API response:", response);

      if (response.data) {
        setApiContractData(response?.data);
        setApiContracts(response?.data?.contract);
        console.log("Contract data fetched successfully:", response.data);
      }
    } catch (error) {
      console.error("Error fetching contract data:", error);
      setError("Failed to fetch contract data");
    } finally {
      setLoading(false);
    }
  };

  const fetchRecords = async () => {
    const defaultContractId = contractId || "06292025-1";

    setLoading(true);
    setError(null);

    try {
      const apiUrl = `http://ec2-34-230-167-131.compute-1.amazonaws.com/contract-managment-service/record?sortBy=ASCENDING&offset=0&limit=10&noDays=10&contractId=${defaultContractId}`;
      console.log("Fetching records with API URL:", apiUrl);

      const accessToken = Auth();
      const headers = {
        "Content-Type": "application/json",
        "X-tenantID": TenantID,
        "X-Authorization": `Bearer ${accessToken}`,
      };

      console.log("Request headers:", headers);

      const response = await axios.get(apiUrl, {
        headers: headers,
      });

      console.log("Records API response:", response);

      if (response.data) {
        const recordsData = Array.isArray(response.data)
          ? response.data
          : [response.data];
        setRecords(recordsData);
        console.log("Records fetched successfully:", recordsData);
        if (recordsData.length > 0) {
          const firstRecord = recordsData[0];
          setFormData((prev) => ({
            ...prev,
            contractId: firstRecord.contractId?.id || prev.contractId,
            ecatsId: firstRecord.recordUniqueId || prev.ecatsId,
            recordName: firstRecord.contractName || prev.recordName,
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching records:", error);
      setError("Failed to fetch records");
    } finally {
      setLoading(false);
    }
  };

  const getWorkflowSectionStatus = (sectionTitle, workflowData) => {
    if (!workflowData) {
      return "inactive";
    }

    switch (sectionTitle) {
      case "Activity Logging":
        if (workflowData.timesheetWorkflows && workflowData.timesheetWorkflows.length > 0) {
          const hasIncompleteActivityLogging = workflowData.timesheetWorkflows.some(workflow => {
            const activityLogDetail = workflow.activityLoggerDetail;
            return !activityLogDetail || activityLogDetail.completionStatus !== "COMPLETED";
          });

          const hasPartialActivityLogging = workflowData.timesheetWorkflows.some(workflow => {
            const activityLogDetail = workflow.activityLoggerDetail;
            return activityLogDetail && activityLogDetail.completionStatus === "PARTIAL";
          });

          if (hasIncompleteActivityLogging) {
            return hasPartialActivityLogging ? "partial" : "not_completed";
          }
          return "completed";
        }
        return "inactive";

      case "Timesheet Creation & Submission":
        if (workflowData.timesheetWorkflows && workflowData.timesheetWorkflows.length > 0) {
          const hasSubmissionUsers = workflowData.timesheetWorkflows.some(workflow =>
            workflow.timesheetSubmissionUser !== null
          );

          if (!hasSubmissionUsers) {
            return "not_completed";
          }

          const hasIncompleteSubmission = workflowData.timesheetWorkflows.some(workflow => {
            const submissionUser = workflow.timesheetSubmissionUser;
            return submissionUser && submissionUser.completionStatus !== "COMPLETED";
          });

          const hasPartialSubmission = workflowData.timesheetWorkflows.some(workflow => {
            const submissionUser = workflow.timesheetSubmissionUser;
            return submissionUser && submissionUser.completionStatus === "PARTIAL";
          });

          if (hasIncompleteSubmission) {
            return hasPartialSubmission ? "partial" : "not_completed";
          }
          return "completed";
        }
        return "inactive";

      case "Timesheet Review & Approval":
        if (workflowData.timesheetWorkflows && workflowData.timesheetWorkflows.length > 0) {
          const hasWorkflowConfig = workflowData.timesheetWorkflows.some(workflow =>
            workflow.timesheetWorkflowConfiguration !== null
          );

          if (!hasWorkflowConfig) {
            return "not_completed";
          }

          const hasIncompleteWorkflow = workflowData.timesheetWorkflows.some(workflow => {
            const config = workflow.timesheetWorkflowConfiguration;
            if (!config) return true;

            if (config.completionStatus === "NOT_COMPLETED") return true;
            if (!config.hasTimesheetApproval) return true;
            if (!config.authorizedUserIds || config.authorizedUserIds.length === 0) return true;

            return false;
          });

          const hasPartialWorkflow = workflowData.timesheetWorkflows.some(workflow => {
            const config = workflow.timesheetWorkflowConfiguration;
            return config && config.completionStatus === "PARTIAL";
          });

          if (hasIncompleteWorkflow) {
            return hasPartialWorkflow ? "partial" : "not_completed";
          }
          return "completed";
        }
        return "inactive";

      case "Invoice Review & Approval":
        if (workflowData.invoiceWorkflows && workflowData.invoiceWorkflows.length > 0) {
          // If invoiceWorkflowControlLevelBy is CONTRACT and all invoices are NOT_COMPLETED,
          // treat as inactive — not yet configured, don't block workflow completion
          if (workflowData.invoiceWorkflowControlLevelBy === 'CONTRACT') {
            const allNotCompleted = workflowData.invoiceWorkflows.every(invoiceWorkflow =>
              !invoiceWorkflow.completionStatus || invoiceWorkflow.completionStatus === 'NOT_COMPLETED'
            );
            if (allNotCompleted) {
              return "inactive";
            }
          }

          const hasIncompleteInvoice = workflowData.invoiceWorkflows.some(invoiceWorkflow => {
            if (invoiceWorkflow.completionStatus === "NOT_COMPLETED") return true;

            return false;
          });

          const hasPartialInvoice = workflowData.invoiceWorkflows.some(invoiceWorkflow => {
            return invoiceWorkflow.completionStatus === "PARTIAL";
          });

          if (hasIncompleteInvoice) {
            return hasPartialInvoice ? "partial" : "not_completed";
          }
          return "completed";
        }
        return "inactive";

      default:
        return "inactive";
    }
  };

  const getAlertsAndIcons = () => {
    const alerts = [];
    const alertIcons = [];

    if (apiContractData?.contract) {
      const contract = apiContractData.contract;

      let hasDocuments = false;
      let documentCount = 0;

      if (contract.contractDetail?.contractFiles && contract.contractDetail.contractFiles.length > 0) {
        const validDocuments = contract.contractDetail.contractFiles.filter(file =>
          file && file.fileURL && file.fileURL.trim() !== ''
        );

        if (validDocuments.length > 0) {
          hasDocuments = true;
          documentCount = validDocuments.length;
        }
      }

      const contractSections = [
        {
          title: "Attached Contract Document(s)",
          subtitle: hasDocuments ? `${documentCount} Documents` : "No Documents",
          status: hasDocuments ? "completed" : "not_completed"
        },
        {
          title: "Contract Identification & Term Limit",
          status: (() => {
            if (contract.contractDetail) {
              return "completed";
            }

            if (!contract.contractDetail) {
              return "inactive";
            }

            return "inactive";
          })()
        },
        {
          title: "Contracted Services Provider(s)",
          status: (() => {
            if (contract.contractServiceProviders?.length > 0) {
              const hasIncompleteProviders = contract.contractServiceProviders.some(provider => {
                const hasBasicInfo = provider.name?.firstName &&
                  provider.name?.lastName &&
                  provider.contractedServiceProviderType?.id;

                return !hasBasicInfo;
              });

              if (hasIncompleteProviders) {
                return "not_completed";
              } else {
                return "completed";
              }
            } else {
              return "completed";
            }
          })()
        },
        {
          title: "Contractor Business Entity",
          status: (() => {
            if (!contract.contractorBusinessEntity || contract.contractorBusinessEntity.id === null) {
              return "inactive";
            }

            if (contract.contractorBusinessEntity.completionStatus === "NOT_COMPLETED") {
              return "not_completed";
            }
            if (contract.contractorBusinessEntity.completionStatus === "PARTIAL") {
              return "partial";
            }
            if (contract.contractorBusinessEntity.completionStatus === "COMPLETED") {
              return "completed";
            }

            return "inactive";
          })()
        },
        {
          title: "Contracted Services Specification",
          status: (() => {
            if (!contract.contractedServices || contract.contractedServices.length === 0) {
              return "inactive";
            }

            const hasNotCompletedServices = contract.contractedServices.some(service =>
              service.completionStatus === "NOT_COMPLETED"
            );
            const hasPartialServices = contract.contractedServices.some(service =>
              service.completionStatus === "PARTIAL"
            );
            const hasCompletedServices = contract.contractedServices.some(service =>
              service.completionStatus === "COMPLETED"
            );

            if (hasNotCompletedServices) {
              return "not_completed";
            }
            if (hasPartialServices) {
              return "partial";
            }
            if (hasCompletedServices) {
              return "completed";
            }

            return "inactive";
          })()
        },
        {
          title: "Timesheet Submission Terms",
          status: (() => {
            const timesheetTermsArray = Array.isArray(contract.timesheetSubmissionTerms) ?
              contract.timesheetSubmissionTerms :
              (contract.timesheetSubmissionTerms ? [contract.timesheetSubmissionTerms] : []);

            if (timesheetTermsArray.length === 0) {
              return "inactive";
            }

            const hasNotCompletedTerms = timesheetTermsArray.some(terms =>
              terms.completionStatus === "NOT_COMPLETED"
            );
            const hasPartialTerms = timesheetTermsArray.some(terms =>
              terms.completionStatus === "PARTIAL"
            );
            const hasCompletedTerms = timesheetTermsArray.some(terms =>
              terms.completionStatus === "COMPLETED"
            );

            if (hasNotCompletedTerms) {
              return "not_completed";
            }
            if (hasPartialTerms) {
              return "partial";
            }
            if (hasCompletedTerms) {
              return "completed";
            }

            return "inactive";
          })()
        },
        {
          title: "Payment & Compensation",
          status: (() => {
            if (!contract.paymentAndCompensation) {
              return "inactive";
            }
            if (contract.paymentAndCompensation.completionStatus === "NOT_COMPLETED") {
              return "not_completed";
            }
            if (contract.paymentAndCompensation.completionStatus === "PARTIAL") {
              return "partial";
            }
            if (contract.paymentAndCompensation.completionStatus === "COMPLETED") {
              return "completed";
            }

            return "inactive";
          })()
        }
      ];

      // Workflow validation
      const workflowSections = [
        {
          title: "Activity Logging",
          status: getWorkflowSectionStatus("Activity Logging", workflowData)
        },
        {
          title: "Timesheet Creation & Submission",
          status: getWorkflowSectionStatus("Timesheet Creation & Submission", workflowData)
        },
        {
          title: "Timesheet Review & Approval",
          status: getWorkflowSectionStatus("Timesheet Review & Approval", workflowData)
        },
        // Only include Invoice if not controlled at site level
        ...(!siteControlledAtSiteLevel ? [{
          title: "Invoice Review & Approval",
          status: getWorkflowSectionStatus("Invoice Review & Approval", workflowData)
        }] : [])
      ];

      console.log('Workflow Data:', workflowData);
      console.log('Workflow Sections Status:', workflowSections.map(section => ({ title: section.title, status: section.status })));

      const sectionsWithWarnings = contractSections.filter(section => section.status === 'not_completed');
      const sectionsWithPartials = contractSections.filter(section => section.status === 'partial');
      const allContractSectionsCompleted = contractSections.every(section => section.status === 'completed');

      const incompleteWorkflows = workflowSections.filter(section =>
        section.status === 'not_completed'
      );
      const partialWorkflows = workflowSections.filter(section => section.status === 'partial');
      const activeSections = workflowSections.filter(section => section.status !== 'inactive');
      const allWorkflowsCompleted = activeSections.length > 0 &&
        activeSections.every(section => section.status === 'completed');

      if (sectionsWithWarnings.length > 0) {
        alerts.push("Contract Data Required");
      } else if (sectionsWithPartials.length > 0) {
        alerts.push("Contract Data Partially Completed");
      } else {
        alerts.push("Contract Data Completed");
      }

      if (incompleteWorkflows.length > 0) {
        alerts.push("Workflow Configuration Incomplete");
      } else if (partialWorkflows.length > 0) {
        alerts.push("Workflow Configuration Partially Completed");
      } else {
        alerts.push("Workflow Configuration Completed");
      }

      if (sectionsWithWarnings.length > 0) {
        alertIcons.push(fileIcon);
      } else if (sectionsWithPartials.length > 0) {
        alertIcons.push(yellowWarning);
      } else if (allContractSectionsCompleted) {
        alertIcons.push(CompletedIcon);
      } else {
        alertIcons.push(fileIcon);
      }

      if (incompleteWorkflows.length > 0) {
        alertIcons.push(fileIcon);
      } else if (partialWorkflows.length > 0) {
        alertIcons.push(yellowWarning);
      } else if (allWorkflowsCompleted) {
        alertIcons.push(CompletedIcon);
      } else {
        alertIcons.push(fileIcon);
      }

    } else {
      alerts.push("Contract Data Not Available");
      alertIcons.push(fileIcon);
      alerts.push("Workflow Data Not Available");
      alertIcons.push(fileIcon);
    }

    return { alerts, alertIcons };
  };


  const { alerts, alertIcons } = getAlertsAndIcons();

  const fetchWorkflowData = async (apiContractId) => {
    try {
      console.log('Fetching workflow data for contractId:', apiContractId);
      const response = await GET(`timesheet-management-service/contractWorkflow/${apiContractId}`);
      console.log('Workflow API response:', response.data);
      setWorkflowData(response.data);
    } catch (error) {
      console.error('Error fetching workflow data:', error);
      setWorkflowData(null);
    }
  };

  // Helper to check if contract is site-controlled
  const checkSiteControlLevel = (contractData, sites) => {
    try {
      const primarySite = contractData?.contract?.contractDetail?.site?.sites?.find(site => site.primarySite === true);
      const contractSiteIds = primarySite ? [primarySite.id] : [];
      const siteControlledSites = (sites || []).filter(site =>
        contractSiteIds.includes(site.id) &&
        site.invoiceWorkflowControlLevelBy !== 'CONTRACT'
      );
      return siteControlledSites.length > 0;
    } catch (error) {
      console.error('Error checking site control level:', error);
      return false;
    }
  };

  useEffect(() => {
    let isMounted = true;
    const fetchAll = async () => {
      if (isOpen) {
        setLoading(true);
        try {
          const apiContractId = contractId;
          console.log('Making API call for contractId:', apiContractId);

          const [contractResponse] = await Promise.all([
            GET(`contract-managment-service/contracts/${apiContractId}`),
            fetchWorkflowData(apiContractId)
          ]);

          const contractData = contractResponse?.data;
          setApiContractData(contractData);
          setApiContracts(contractData?.contract);
          const contract = contractData?.contract || contractData;
          if (contract?.timesheetWorkflows || contract?.invoiceWorkflows) {
            setWorkflowData(prevWorkflowData => {
              if (!prevWorkflowData) {
                return {
                  timesheetWorkflows: contract.timesheetWorkflows || [],
                  invoiceWorkflows: contract.invoiceWorkflows || [],
                  invoiceWorkflowControlLevelBy: contract.invoiceWorkflowControlLevelBy
                };
              }
              return prevWorkflowData;
            });
          }

          // Fetch sites data
          const sitesResponse = await GET('entity-service/sites');
          const sites = sitesResponse?.data || [];
          setSitesData(sites);

          // Check site control level
          const isSiteControlled = checkSiteControlLevel(contractData, sites);
          setSiteControlledAtSiteLevel(isSiteControlled);

          // Fetch records (if needed)
          await fetchRecords();
        } catch (error) {
          console.error('Error in fetchAll:', error);
        } finally {
          if (isMounted) setLoading(false);
        }
      }
    };
    fetchAll();
    return () => { isMounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, contractId]);

  if (!isOpen) return null;

  console.log(apiContracts?.contractDetail, "contractDetail");

  return (
    <Dialog
      isOpen={isOpen}
      className={`${styles.dialogStyle} ${styles.dialogPaddingBottom}`}
    >
      <div
        className={`${Classes.DIALOG_BODY} ${styles.extensionDialogBackground}`}
      >
        <div className={styles.spaceBetween}>
          <p className={styles.extensionStyle}>View Source Record</p>
          <Icon
            icon="cross"
            size={20}
            intent={Intent.DANGER}
            className={styles.crossStyle}
            onClick={onClose}
          />
        </div>
        <div className={styles.extensionBorder}></div>
        <div style={{ paddingTop: "10px" }}>
          <div className={styles.headerRow}>
            <div
              className={
                displayEcats ? `${styles.headerLeft}` : `${styles.headerLeft}`
              }
            >
              <div className={`${styles.headerContent} ${styles.fullWidth}`}>
                <div className={styles.headerTitleRow}>
                  <span className={styles.contractMainTitle}>
                    {apiContractData?.contract?.contractName?.contractName ||
                      contractData?.contractName?.contractName ||
                      contractData?.contractName ||
                      "Contract Name"}
                  </span>
                  <span className={styles.draftLabel}>
                    -{" "}
                    {apiContractData?.contract?.contractStatus ||
                      contractData?.contractStatus ||
                      "DRAFT"}
                  </span>
                </div>
                <div className={styles.contractSubtitle}>
                  {apiContractData?.contract?.contractType === "INDIVIDUAL"
                    ? "Solo Provider Contract"
                    : apiContractData?.contract?.contractType === "MULTIPLE"
                      ? "Multi Provider Contract"
                      : apiContractData?.contract?.contractType === "BATCH"
                        ? "Batch Provider Contract"
                        : contractData?.contractType === "INDIVIDUAL"
                          ? "Solo Provider Contract"
                          : contractData?.contractType === "MULTIPLE"
                            ? "Multi Provider Contract"
                            : contractData?.contractType === "BATCH"
                              ? "Batch Provider Contract"
                              : "Contract Type"}
                </div>
                <div className={styles.statusRow}>
                  <div className={styles.alertRow}>
                    {alerts.map((alert, index) => (
                      <div key={index} className={styles.statusAlert}>
                        <img
                          src={alertIcons[index]}
                          alt="Alert"
                          className={styles.alertIcon}
                        />
                        <span className={styles.statusAlertText}>{alert}</span>
                      </div>
                    ))}
                  </div>
                  <div className={styles.lastUpdated}>
                    Last Updated:{" "}
                    {apiContractData?.contract?.lastModifiedDate
                      ? format(
                        new Date(apiContractData.contract.lastModifiedDate),
                        "MMM dd, yyyy"
                      )
                      : contractData?.lastModifiedDate
                        ? format(
                          new Date(contractData.lastModifiedDate),
                          "MMM dd, yyyy"
                        )
                        : "N/A"}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.headerRight}>
              <div
                className={
                  displayEcats
                    ? `${styles.contractInfo}`
                    : `${styles.contractInfoECAT}`
                }
              >
                <div className={styles.infoLabel}>Contract ID</div>
                <div className={styles.infoValue}>
                  {apiContractData?.contract?.contractDetail?.contractId?.id ||
                    contractData?.contractDetail?.contractId?.id ||
                    contractData?.contractId ||
                    contractData?.id ||
                    contractId ||
                    "N/A"}
                </div>
              </div>
              {displayEcats && (
                <div className={styles.contractInfo}>
                  <div className={styles.infoLabel}>
                    {ecatsLabel ? ecatsLabel : ""}
                  </div>
                  <div className={styles.infoValue}>
                    {apiContractData?.contract?.contractDetail?.contractId
                      ?.id ||
                      contractData?.contractDetail?.contractId?.id ||
                      contractData?.contractId ||
                      contractData?.id ||
                      contractId ||
                      "N/A"}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionTitle}>
            Record Identification & Term Limit
          </h3>
          {/* <button className={styles.resendButton}>
            SEND REQUEST TO RESEND RECORD
          </button> */}
        </div>
        <div className={styles.content}>
          <div className={styles.section}>
            {/* <div className={styles.formGrid}>
                              <div className={styles.inputGroupFull}>
                                <label className={styles.label}>eCATS ID</label>
                                <CommonInputField
                                    type="text"
                                    value={formData.ecatsId}
                                    onChange={e => handleInputChange('ecatsId', e.target.value)}
                                    placeholder="eCATS ID"
                                />
                              </div>

                              <div className={styles.inputGroupFull}>
                                <label className={styles.label}>Record Name*</label>
                                <CommonInputField
                                    type="text"
                                    value={formData.recordName}
                                    onChange={(e) => handleInputChange('recordName', e.target.value)}
                                />
                            </div>

                            <div className={styles.inputGroup}>
                                <label className={styles.label}>Starting & Ending Dates</label>
                                <div className={styles.dateRange}>
                                    <div className={styles.dateInput}>
                                        <CommonDateField />
                                    </div>
                                    <span className={styles.dateSeparator}>to</span>
                                    <div className={styles.dateInput}>
                                        <CommonDateField />
                                    </div>
                                </div>
                            </div>
                            </div> */}

            {/* Hide eCATS ID label and value if siteId is San Mateo Medical Center (dynamic) */}
            {(() => {
              const contractSites = apiContracts?.contractDetail?.site?.sites || [];
              // Find San Mateo Medical Center siteId from sitesData
              const sanMateoSite = sitesData.find(site => site?.siteName?.siteName === "San Mateo Medical Center");
              const sanMateoSiteId = sanMateoSite?.id;
              const hasSanMateo = sanMateoSiteId && contractSites.some(site => site?.id === sanMateoSiteId);
              if (hasSanMateo) {
                return null; // Hide eCATS ID for San Mateo Medical Center
              }
              return (
                <div className={styles.displayInline}>
                  <div className={styles.fixedWid}>
                    <CommonLabel value="eCATS ID" />
                  </div>
                  <span className={styles.grayFont}>
                    {apiContracts?.contractDetail != null
                      ? apiContracts?.contractDetail?.contractId
                        ? apiContracts?.contractDetail?.contractId?.id
                        : ""
                      : ""}
                  </span>
                </div>
              );
            })()}

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Record Name" />
              </div>

              <span className={styles.grayFont}>
                {apiContracts?.contractName != null
                  ? apiContracts?.contractName?.contractName
                  : ""}
              </span>
            </div>
            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Record Status" />
              </div>

              <span className={styles.grayFont}>
                {apiContracts?.contractStatus != null
                  ? apiContracts?.contractStatus
                  : ""}
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Starting & Ending Dates" />
              </div>

              <span className={styles.grayFont}>
                {apiContracts?.contractDetail != null &&
                  apiContracts?.contractDetail?.contractTerm
                  ? apiContracts.contractDetail.contractTerm.startDate
                    ? apiContracts.contractDetail.contractTerm.startDate
                      .split("-")
                      .map(
                        (val, idx, arr) =>
                          idx === 0
                            ? arr[1] // month
                            : idx === 1
                              ? arr[2] // day
                              : arr[0] // year
                      )
                      .join("/")
                    : ""
                  : ""}{" "}{" "}
                to{" "}{" "}
                {apiContracts?.contractDetail != null &&
                  apiContracts?.contractDetail?.contractTerm
                  ? apiContracts.contractDetail.contractTerm.endDate
                    ? apiContracts.contractDetail.contractTerm.endDate
                      .split("-")
                      .map(
                        (val, idx, arr) =>
                          idx === 0
                            ? arr[1] // month
                            : idx === 1
                              ? arr[2] // day
                              : arr[0] // year
                      )
                      .join("/")
                    : ""
                  : ""}
              </span>
            </div>

            {/* Hide Multiple Vendor label if siteId is San Mateo Medical Center (dynamic) */}
            {(() => {
              const contractSites = apiContracts?.contractDetail?.site?.sites || [];
              // Find San Mateo Medical Center siteId from sitesData
              const sanMateoSite = sitesData.find(site => site?.siteName?.siteName === "San Mateo Medical Center");
              const sanMateoSiteId = sanMateoSite?.id;
              const hasSanMateo = sanMateoSiteId && contractSites.some(site => site?.id === sanMateoSiteId);
              if (hasSanMateo) {
                return null; // Hide Multiple Vendor label for San Mateo Medical Center
              }
              return (
                <div className={styles.displayInline}>
                  <div className={styles.fixedWid}>
                    <CommonLabel value="Multiple Vendor" />
                  </div>
                  <span className={styles.grayFont}>
                    {apiContracts?.contractDetail != null
                      ? apiContracts?.contractDetail?.hasMultipleVendorDetails
                      : ""}
                  </span>
                </div>
              );
            })()}

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Compensation Policy" />
              </div>

              <span className={styles.grayFont}>
                {apiContracts?.contractDetail != null
                  ? apiContracts?.contractDetail?.compensationPolicy
                  : ""}
              </span>
            </div>

            {/* <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel
                  value="Fully Executed Contract
Documents Available"
                />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Service Provider Type / NPIN*" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Contractor Name*" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Suffix" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Vendor NPIN" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Business Entity Name" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Business Point Of Contact" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Business Contact Email Address" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Cell Phone" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Mailing Address" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Street Address" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="City" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="State" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.displayInline}>
              <div className={styles.fixedWid}>
                <CommonLabel value="Zipcode" />
              </div>

              <span className={styles.grayFont}>
                
                
              </span>
            </div>

            <div className={styles.inputGroup}>
              <div className={styles.inputRadioStyle}>
                <label className={styles.label}>
                  Fully Executed Contract
                  <br /> Documents Available*
                </label>
                <div className={styles.toggleGroup}>
                  <CommonSwitch
                    checked={formData.fullyExecuted}
                    onChange={() => handleToggle("fullyExecuted")}
                    className={styles.switch}
                  />
                  <span className={styles.toggleLabel}>
                    {formData.fullyExecuted ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>

            <div className={styles.rawDataSection}>
              <div className={styles.rawDataContent}>
                <div className={styles.fileItem}>
                  <img src={pdf} alt="File" className={styles.fileIcon} />
                  <span className={styles.fileName}>
                    Executed Contract (Current)
                  </span>
                </div>
                <div className={styles.fileDescription}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  <br />
                  Fgg.Jpg.
                </div>
              </div>
            </div>
          </div>
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>
              Contracted Services Provider(s)
            </h3>

            <div className={styles.inputGroup}>
              <div className={styles.inputRadioStyle}>
                <label className={styles.label}>
                  Specific Service Providers <br /> Mentioned in Contract
                </label>
                <div className={styles.toggleGroup}>
                  <CommonSwitch
                    checked={formData.specificProviders}
                    onChange={() => handleToggle("specificProviders")}
                    className={styles.switch}
                  />
                  <span className={styles.toggleLabel}>
                    {formData.specificProviders ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>
                Service Provider Type / NPIN*
              </label>
              <div className={styles.grid}>
                <CommonInputField
                  type="text"
                  value="Text"
                  onChange={(e) =>
                    handleInputChange("recordName", e.target.value)
                  }
                />
                <div className={styles.radioGroup}>
                  <div className={styles.radioItem}>
                    <input
                      type="radio"
                      id="npin-missing"
                      name="npinStatus"
                      value="missing"
                      checked={formData.npinStatus === "missing"}
                      onChange={() =>
                        handleInputChange("npinStatus", "missing")
                      }
                      className={styles.radio}
                      style={{ display: "none" }}
                    />
                    <div
                      className={`${styles.radioButton} ${
                        formData.npinStatus === "missing" ? styles.selected : ""
                      }`}
                      onClick={() => handleInputChange("npinStatus", "missing")}
                    />
                    <label
                      className={styles.radioLabel}
                      onClick={() => handleInputChange("npinStatus", "missing")}
                    >
                      Missing
                    </label>
                  </div>
                  <div className={styles.radioItem}>
                    <input
                      type="radio"
                      id="npin-na"
                      name="npinStatus"
                      value="na"
                      checked={formData.npinStatus === "na"}
                      onChange={() => handleInputChange("npinStatus", "na")}
                      className={styles.radio}
                      style={{ display: "none" }}
                    />
                    <div
                      className={`${styles.radioButton} ${
                        formData.npinStatus === "na" ? styles.selected : ""
                      }`}
                      onClick={() => handleInputChange("npinStatus", "na")}
                    />
                    <label
                      htmlFor="npin-na"
                      className={styles.radioLabel}
                      onClick={() => handleInputChange("npinStatus", "na")}
                    >
                      Not Applicable
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Contractor Name*</label>
              <div className={styles.nameGrid}>
                <CommonInputField
                  placeholder="First"
                  value={formData.contractorFirstName}
                  onChange={(e) =>
                    handleInputChange("contractorFirstName", e.target.value)
                  }
                />
                <CommonInputField
                  placeholder="Middle"
                  value={formData.contractorMiddleName}
                  onChange={(e) =>
                    handleInputChange("contractorMiddleName", e.target.value)
                  }
                />
                <CommonInputField
                  placeholder="Last"
                  value={formData.contractorLastName}
                  onChange={(e) =>
                    handleInputChange("contractorLastName", e.target.value)
                  }
                  style={{ height: 40 }}
                />
              </div>
              <label className={styles.label}>Suffix</label>
              <CommonSelectField
                value={formData.contractorSuffix}
                onChange={(e) =>
                  handleInputChange("contractorSuffix", e.target.value)
                }
                valueList={["", "Jr", "Sr", "II", "III"]}
                labelList={["Jr", "Sr", "II", "III"]}
                firstOptionLabel="Suffix"
                firstOptionValue=""
                className={styles.selectField}
                widthValue={450}
                style={{ height: 24 }}
              />
            </div>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Contractor Business Entity</h3>

            <div className={styles.inputGroup}>
              <div className={styles.inputRadioStyle}>
                <label className={styles.label}>
                  Vendor Contracting Using <br /> A Business Entity*
                </label>
                <div className={styles.toggleGroup}>
                  <CommonSwitch
                    checked={formData.vendorUsingEntity}
                    onChange={() => handleToggle("vendorUsingEntity")}
                    className={styles.switch}
                  />
                  <span className={styles.toggleLabel}>
                    {formData.vendorUsingEntity ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>

            <div className={styles.inputGroupFull}>
              <label className={styles.label}>Vendor NPIN*</label>
              <div className={styles.grid}>
                <CommonInputField
                  placeholder="Alphanumeric"
                  value={formData.vendorNPIN}
                  onChange={(e) =>
                    handleInputChange("vendorNPIN", e.target.value)
                  }
                />
                <div className={styles.radioGroup}>
                  <div className={styles.radioItem}>
                    <input
                      type="radio"
                      id="npin-missing"
                      name="npinStatus"
                      value="missing"
                      checked={formData.npinStatus === "missing"}
                      onChange={() =>
                        handleInputChange("npinStatus", "missing")
                      }
                      className={styles.radio}
                      style={{ display: "none" }}
                    />
                    <div
                      className={`${styles.radioButton} ${
                        formData.npinStatus === "missing" ? styles.selected : ""
                      }`}
                      onClick={() => handleInputChange("npinStatus", "missing")}
                    />
                    <label
                      htmlFor="npin-missing"
                      className={styles.radioLabel}
                      onClick={() => handleInputChange("npinStatus", "missing")}
                    >
                      Missing
                    </label>
                  </div>
                  <div className={styles.radioItem}>
                    <input
                      type="radio"
                      id="npin-na"
                      name="npinStatus"
                      value="na"
                      checked={formData.npinStatus === "na"}
                      onChange={() => handleInputChange("npinStatus", "na")}
                      className={styles.radio}
                      style={{ display: "none" }}
                    />
                    <div
                      className={`${styles.radioButton} ${
                        formData.npinStatus === "na" ? styles.selected : ""
                      }`}
                      onClick={() => handleInputChange("npinStatus", "na")}
                    />
                    <label
                      htmlFor="npin-na"
                      className={styles.radioLabel}
                      onClick={() => handleInputChange("npinStatus", "na")}
                    >
                      Not Applicable
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Business Entity Name*</label>
              <CommonInputField
                type="text"
                value={formData.businessEntityName}
                onChange={(e) =>
                  handleInputChange("businessEntityName", e.target.value)
                }
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Business Point Of Contact*</label>
              <div className={styles.contactGrid}>
                <CommonInputField
                  placeholder="First Name"
                  value={formData.businessContactFirstName}
                  onChange={(e) =>
                    handleInputChange(
                      "businessContactFirstName",
                      e.target.value
                    )
                  }
                />
                <CommonInputField
                  placeholder="Last Name"
                  value={formData.businessContactLastName}
                  onChange={(e) =>
                    handleInputChange("businessContactLastName", e.target.value)
                  }
                />
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>
                Business Contact Email Address*
              </label>
              <CommonInputField
                type="email"
                value={formData.businessEmail}
                onChange={(e) =>
                  handleInputChange("businessEmail", e.target.value)
                }
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Cell Phone*</label>
              <div className={styles.phoneGroup}>
                <div className={styles.phoneInput}>
                  <span className={styles.phonePrefix}>+1</span>
                  <input
                    type="tel"
                    value={formData.cellPhone}
                    onChange={(e) =>
                      handleInputChange("cellPhone", e.target.value)
                    }
                    className={styles.phoneNumber}
                  />
                </div>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Mailing Address*</label>
              <div className={styles.addressGroup}>
                <CommonInputField
                  placeholder="Street address"
                  value={formData.streetAddress}
                  onChange={(e) =>
                    handleInputChange("streetAddress", e.target.value)
                  }
                />
                <div className={styles.addressGrid}>
                  <CommonInputField
                    type="text"
                    placeholder="City"
                    value={formData.city}
                    onChange={(e) => handleInputChange("city", e.target.value)}
                  />
                  <CommonInputField
                    type="text"
                    placeholder="State"
                    value={formData.state}
                    onChange={(e) => handleInputChange("state", e.target.value)}
                  />
                  <CommonInputField
                    type="text"
                    placeholder="Zipcode"
                    value={formData.zipcode}
                    onChange={(e) =>
                      handleInputChange("zipcode", e.target.value)
                    }
                  />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ViewSourceRecord;
